export const ACCOUNT_BRAND_ID = 0;
export const BRAND_ONBOARDING_MODAL_STATE = {
  HOME: 'home',
  LOGO: 'logo',
  FAVICON: 'favicon',
  COLOR: 'color'
};